import React from 'react';
import {File, FileAudio, FileDoc, FilePdf, FileText, Image} from '../../../icons';
import {FILE_KIND} from '../../memory/ingestFiles';

// Ícono Phosphor por tipo de archivo (tira de subidas de la Barra Total, lista de ingesta). El mapa de FontAwesome para la tabla clásica vive en `memory/ingestFiles.js`
// (`fileKindFaIcon`): ese módulo es puro y no puede importar componentes.
const ICON = {
    [FILE_KIND.PDF]: FilePdf,
    [FILE_KIND.DOCX]: FileDoc,
    [FILE_KIND.IMAGE]: Image,
    [FILE_KIND.AUDIO]: FileAudio,
    [FILE_KIND.TEXT]: FileText,
};

export function FileKindIcon({kind, size = 15, ...rest}) {
    const Icon = ICON[kind] || File;
    return <Icon size={size} aria-hidden="true" {...rest}/>;
}

export default FileKindIcon;
